// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SvHw","placeholdersHeader":"styles_placeholdersHeader__1A-Ei","editorStyle":"styles_editorStyle__1OKQy","placeholdersBox":"styles_placeholdersBox__17DQB"};